module.exports = __webpack_public_path__ + "static/img/ic_logo_jns_menu.997d3eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_logo_jns_menu.png
// module id = nJAj
// module chunks = 0